$(document).ready( function(){
	if ($('.menu__trigger').length > 0){
	    $('.menu__trigger').click( function(){
	    	$(this).toggleClass('open');
	        $('.menu').toggleClass('open');
	        $('header').delay(2000).toggleClass('menu_panel');
	    });
	}
});
